import { ReactElement, forwardRef } from 'react';

import { ButtonIcon, Tooltip, TooltipTrigger } from '@backstage/ui';

import { useDialogContext } from './context';

export type TriggerButtonIconProps = {
  icon: ReactElement;
  tooltip?: string;
  'aria-label': string;
  disabled?: boolean;
  className?: string;
};

export const TriggerButtonIcon = forwardRef<
  HTMLButtonElement,
  TriggerButtonIconProps
>((props, ref) => {
  const { icon, tooltip, disabled, ...rest } = props;
  const { onOpen, isLoading } = useDialogContext();

  const button = (
    <ButtonIcon
      ref={ref}
      size="small"
      variant="tertiary"
      isDisabled={disabled || isLoading}
      isPending={isLoading}
      onPress={onOpen}
      icon={icon}
      data-track-action="open-dialog"
      {...rest}
    />
  );

  if (!tooltip) return button;

  return (
    <TooltipTrigger>
      {button}
      <Tooltip placement="left">{tooltip}</Tooltip>
    </TooltipTrigger>
  );
});

TriggerButtonIcon.displayName = 'DialogComposite.TriggerButtonIcon';

export default TriggerButtonIcon;
